module.exports = __webpack_public_path__ + "img/round-format_align_center-24px.4647369a.svg";